function moneyFormat(amount: number | string , currency: string): string{
  let convertedAmount = 0; 
  let digits = 0;

  if (typeof(amount) === "string"){
    convertedAmount = parseFloat((amount ?? "0"));
  } else if (typeof(amount) === "number") {
    convertedAmount = amount
  } else {
    convertedAmount = 0;
  }

  switch (currency){
    case "CLP":
      digits = 0;
      break;
    case "USD":
      digits = 2;
      break;
    case "UF":
      return convertedAmount.toString();
  }

  const formatter = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    minimumFractionDigits: digits,
    currency
  })

  return formatter.format(convertedAmount);;
}

function getApiDateFormat(date:string){  
  let arrayDate = date.split("/").reverse().join("-");  
  return arrayDate && arrayDate.length === 10? arrayDate: "";
}

function getDateFromTimestamp(date:string | number | undefined){
  let returnDate = "";  
  try {
    if (date && typeof(date) === "string"){            
      returnDate = date.split("T")[0];
    }
  } catch (error) {
    return "";
  }
  return returnDate;
}

function getTimestampFromDate(date:string | undefined){
  let returnDate = "";  
  try {
    if (date && typeof(date) === "string"){  
      returnDate = new Date(date.split("/").reverse().join("-")).toISOString();//RFA
      returnDate = returnDate.replace('00:00:00.000Z', '09:00:00.000Z')
    }
  } catch (error) {
    return "";
  }
  return returnDate;
}

function getAccrualDateToApi(date: string){
  let returnDate = "";
  try{
    if (date && typeof(date) === "string"){
      returnDate = date.split("/").reverse().join("-");
    }
  } catch (error){
    return "";
  }
  return returnDate;
}

function getNumberWithThousandsSeparator(number: number){
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}


export { moneyFormat, getApiDateFormat, getDateFromTimestamp, getTimestampFromDate, getAccrualDateToApi, getNumberWithThousandsSeparator }